import Vue from 'vue'

// import 'expose-loader?$!expose-loader?jQuery!jquery'

// import BootstrapVue from 'bootstrap-vue'
// import 'bootstrap/dist/css/bootstrap.min.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
// import 'bootstrap/dist/js/bootstrap.min.js'
// import Popper from "popper.js";



// Vue.use(BootstrapVue)


import {
  AlertPlugin,
  AvatarPlugin,
  BadgePlugin,
  // BreadcrumbPlugin,
  ButtonPlugin,
  ButtonGroupPlugin,
  // CarouselPlugin,
  CardPlugin,
  CollapsePlugin,
  DropdownPlugin,
  FormPlugin,
  FormCheckboxPlugin,
  FormFilePlugin,
  FormGroupPlugin,
  FormInputPlugin,
  FormSelectPlugin,
  FormTextareaPlugin,
  ImagePlugin,
  InputGroupPlugin,
  LayoutPlugin,
  LinkPlugin,
  ListGroupPlugin,
  MediaPlugin,
  ModalPlugin,
  NavPlugin,
  NavbarPlugin,
  PaginationPlugin,
  PopoverPlugin,
  SidebarPlugin,
  SpinnerPlugin,
  TablePlugin,
  TabsPlugin,
  ToastPlugin,
  TooltipPlugin
} from 'bootstrap-vue';

[
  AlertPlugin,
  AvatarPlugin,
  BadgePlugin,
  // BreadcrumbPlugin,
  ButtonPlugin,
  ButtonGroupPlugin,
  CardPlugin,
  CollapsePlugin,
  // CarouselPlugin,
  DropdownPlugin,
  FormPlugin,
  FormCheckboxPlugin,
  FormFilePlugin,
  FormGroupPlugin,
  FormInputPlugin,
  FormSelectPlugin,
  FormTextareaPlugin,
  ImagePlugin,
  InputGroupPlugin,
  LayoutPlugin,
  LinkPlugin,
  ListGroupPlugin,
  MediaPlugin,
  ModalPlugin,
  NavPlugin,
  NavbarPlugin,
  PaginationPlugin,
  PopoverPlugin,
  SidebarPlugin,
  SpinnerPlugin,
  TablePlugin,
  TabsPlugin,
  TooltipPlugin
].forEach(comp => {
  Vue.use(comp);
});

Vue.use(ToastPlugin, {
  "BToast": {
    autoHideDelay:30000
  }
});



// import bTooltipD from 'bootstrapvue/es/directives/tooltip/tooltip';
//Vue.directive('b-tooltip', bTooltipD);

import "@/scss/custom.scss";
